import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

export default function EditableAutocomplete({
  disabledOptions,
  id,
  isEditing,
  label,
  onChange,
  optionLabel,
  options,
  route,
  state,
  text,
  value = "",
}) {
  return isEditing ? (
    <Autocomplete
      getOptionDisabled={disabledOptions}
      getOptionLabel={optionLabel}
      id={id}
      onChange={onChange}
      options={options}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="dense"
          sx={{
            "& .MuiFilledInput-root": {
              backgroundColor: "backgroundContrast.main",
            },
            "& .MuiInputBase": {
              backgroundColor: "backgroundContrast.main",
            },
            "& .MuiAutocomplete-clearIndicator": {
              color: "secondary.main",
            },
            "& .MuiAutocomplete-popupIndicator": {
              color: "secondary.main",
            },
          }}
          variant="filled"
        />
      )}
      size="small"
    />
  ) : (
    <Typography
      id={id}
      component={route && Link}
      state={state}
      to={route}
      variant="body1"
    >
      {text}
    </Typography>
  );
}
